/* eslint-disable class-methods-use-this */
import { IdmService } from '../kmp'

export default class OAuthAPI {
  async consent({
    userCode,
    scope = 'email profile',
    responseType = 'token',
    decision = 'allow',
  }) {
    return IdmService.consent(userCode, scope, responseType, decision)
  }
}
